
export function remove_percentage(value: number, percentage: number) {
    if (percentage === 0) {
        return value;
    }
    return value - value * percentage / 100;
}
